import React from "react";

export default function InitializationError({
  retry,
}: {
  retry: () => void;
}): React.JSX.Element {
  return (
    <div role="alert" style={{ padding: 32, textAlign: "center" }}>
      <p>Impossible de charger l’application. Veuillez réessayer.</p>
      <button type="button" className="btn btn-primary" onClick={retry}>
        Réessayer
      </button>
    </div>
  );
}
